(()=>{
    var t = {
        487: function() {
            "use strict";
            window.tram = function(t) {
                function e(t, e) {
                    return (new M.Bare).init(t, e);
                }
                function n(t) {
                    var e = parseInt(t.slice(1), 16);
                    return [
                        e >> 16 & 255,
                        e >> 8 & 255,
                        255 & e
                    ];
                }
                function i(t, e, n) {
                    return "#" + (0x1000000 | t << 16 | e << 8 | n).toString(16).slice(1);
                }
                function r() {}
                function o(t, e, n) {
                    if (void 0 !== e && (n = e), void 0 === t) return n;
                    var i = n;
                    return Y.test(t) || !K.test(t) ? i = parseInt(t, 10) : K.test(t) && (i = 1e3 * parseFloat(t)), 0 > i && (i = 0), i == i ? i : n;
                }
                function a(t) {
                    F.debug && window && window.console.warn(t);
                }
                var s, u, c, l = function(t, e, n) {
                    function i(t) {
                        return "object" == typeof t;
                    }
                    function r(t) {
                        return "function" == typeof t;
                    }
                    function o() {}
                    return function a(s, u) {
                        function c() {
                            var t = new l;
                            return r(t.init) && t.init.apply(t, arguments), t;
                        }
                        function l() {}
                        u === n && (u = s, s = Object), c.Bare = l;
                        var d, f = o[t] = s[t], h = l[t] = c[t] = new o;
                        return h.constructor = c, c.mixin = function(e) {
                            return l[t] = c[t] = a(c, e)[t], c;
                        }, c.open = function(t) {
                            if (d = {}, r(t) ? d = t.call(c, h, f, c, s) : i(t) && (d = t), i(d)) for(var n in d)e.call(d, n) && (h[n] = d[n]);
                            return r(h.init) || (h.init = s), c;
                        }, c.open(u);
                    };
                }("prototype", {}.hasOwnProperty), d = {
                    ease: [
                        "ease",
                        function(t, e, n, i) {
                            var r = (t /= i) * t, o = r * t;
                            return e + n * (-2.75 * o * r + 11 * r * r + -15.5 * o + 8 * r + .25 * t);
                        }
                    ],
                    "ease-in": [
                        "ease-in",
                        function(t, e, n, i) {
                            var r = (t /= i) * t, o = r * t;
                            return e + n * (-1 * o * r + 3 * r * r + -3 * o + 2 * r);
                        }
                    ],
                    "ease-out": [
                        "ease-out",
                        function(t, e, n, i) {
                            var r = (t /= i) * t, o = r * t;
                            return e + n * (.3 * o * r + -1.6 * r * r + 2.2 * o + -1.8 * r + 1.9 * t);
                        }
                    ],
                    "ease-in-out": [
                        "ease-in-out",
                        function(t, e, n, i) {
                            var r = (t /= i) * t, o = r * t;
                            return e + n * (2 * o * r + -5 * r * r + 2 * o + 2 * r);
                        }
                    ],
                    linear: [
                        "linear",
                        function(t, e, n, i) {
                            return n * t / i + e;
                        }
                    ],
                    "ease-in-quad": [
                        "cubic-bezier(0.550, 0.085, 0.680, 0.530)",
                        function(t, e, n, i) {
                            return n * (t /= i) * t + e;
                        }
                    ],
                    "ease-out-quad": [
                        "cubic-bezier(0.250, 0.460, 0.450, 0.940)",
                        function(t, e, n, i) {
                            return -n * (t /= i) * (t - 2) + e;
                        }
                    ],
                    "ease-in-out-quad": [
                        "cubic-bezier(0.455, 0.030, 0.515, 0.955)",
                        function(t, e, n, i) {
                            return (t /= i / 2) < 1 ? n / 2 * t * t + e : -n / 2 * (--t * (t - 2) - 1) + e;
                        }
                    ],
                    "ease-in-cubic": [
                        "cubic-bezier(0.550, 0.055, 0.675, 0.190)",
                        function(t, e, n, i) {
                            return n * (t /= i) * t * t + e;
                        }
                    ],
                    "ease-out-cubic": [
                        "cubic-bezier(0.215, 0.610, 0.355, 1)",
                        function(t, e, n, i) {
                            return n * ((t = t / i - 1) * t * t + 1) + e;
                        }
                    ],
                    "ease-in-out-cubic": [
                        "cubic-bezier(0.645, 0.045, 0.355, 1)",
                        function(t, e, n, i) {
                            return (t /= i / 2) < 1 ? n / 2 * t * t * t + e : n / 2 * ((t -= 2) * t * t + 2) + e;
                        }
                    ],
                    "ease-in-quart": [
                        "cubic-bezier(0.895, 0.030, 0.685, 0.220)",
                        function(t, e, n, i) {
                            return n * (t /= i) * t * t * t + e;
                        }
                    ],
                    "ease-out-quart": [
                        "cubic-bezier(0.165, 0.840, 0.440, 1)",
                        function(t, e, n, i) {
                            return -n * ((t = t / i - 1) * t * t * t - 1) + e;
                        }
                    ],
                    "ease-in-out-quart": [
                        "cubic-bezier(0.770, 0, 0.175, 1)",
                        function(t, e, n, i) {
                            return (t /= i / 2) < 1 ? n / 2 * t * t * t * t + e : -n / 2 * ((t -= 2) * t * t * t - 2) + e;
                        }
                    ],
                    "ease-in-quint": [
                        "cubic-bezier(0.755, 0.050, 0.855, 0.060)",
                        function(t, e, n, i) {
                            return n * (t /= i) * t * t * t * t + e;
                        }
                    ],
                    "ease-out-quint": [
                        "cubic-bezier(0.230, 1, 0.320, 1)",
                        function(t, e, n, i) {
                            return n * ((t = t / i - 1) * t * t * t * t + 1) + e;
                        }
                    ],
                    "ease-in-out-quint": [
                        "cubic-bezier(0.860, 0, 0.070, 1)",
                        function(t, e, n, i) {
                            return (t /= i / 2) < 1 ? n / 2 * t * t * t * t * t + e : n / 2 * ((t -= 2) * t * t * t * t + 2) + e;
                        }
                    ],
                    "ease-in-sine": [
                        "cubic-bezier(0.470, 0, 0.745, 0.715)",
                        function(t, e, n, i) {
                            return -n * Math.cos(t / i * (Math.PI / 2)) + n + e;
                        }
                    ],
                    "ease-out-sine": [
                        "cubic-bezier(0.390, 0.575, 0.565, 1)",
                        function(t, e, n, i) {
                            return n * Math.sin(t / i * (Math.PI / 2)) + e;
                        }
                    ],
                    "ease-in-out-sine": [
                        "cubic-bezier(0.445, 0.050, 0.550, 0.950)",
                        function(t, e, n, i) {
                            return -n / 2 * (Math.cos(Math.PI * t / i) - 1) + e;
                        }
                    ],
                    "ease-in-expo": [
                        "cubic-bezier(0.950, 0.050, 0.795, 0.035)",
                        function(t, e, n, i) {
                            return 0 === t ? e : n * Math.pow(2, 10 * (t / i - 1)) + e;
                        }
                    ],
                    "ease-out-expo": [
                        "cubic-bezier(0.190, 1, 0.220, 1)",
                        function(t, e, n, i) {
                            return t === i ? e + n : n * (-Math.pow(2, -10 * t / i) + 1) + e;
                        }
                    ],
                    "ease-in-out-expo": [
                        "cubic-bezier(1, 0, 0, 1)",
                        function(t, e, n, i) {
                            return 0 === t ? e : t === i ? e + n : (t /= i / 2) < 1 ? n / 2 * Math.pow(2, 10 * (t - 1)) + e : n / 2 * (-Math.pow(2, -10 * --t) + 2) + e;
                        }
                    ],
                    "ease-in-circ": [
                        "cubic-bezier(0.600, 0.040, 0.980, 0.335)",
                        function(t, e, n, i) {
                            return -n * (Math.sqrt(1 - (t /= i) * t) - 1) + e;
                        }
                    ],
                    "ease-out-circ": [
                        "cubic-bezier(0.075, 0.820, 0.165, 1)",
                        function(t, e, n, i) {
                            return n * Math.sqrt(1 - (t = t / i - 1) * t) + e;
                        }
                    ],
                    "ease-in-out-circ": [
                        "cubic-bezier(0.785, 0.135, 0.150, 0.860)",
                        function(t, e, n, i) {
                            return (t /= i / 2) < 1 ? -n / 2 * (Math.sqrt(1 - t * t) - 1) + e : n / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + e;
                        }
                    ],
                    "ease-in-back": [
                        "cubic-bezier(0.600, -0.280, 0.735, 0.045)",
                        function(t, e, n, i, r) {
                            return void 0 === r && (r = 1.70158), n * (t /= i) * t * ((r + 1) * t - r) + e;
                        }
                    ],
                    "ease-out-back": [
                        "cubic-bezier(0.175, 0.885, 0.320, 1.275)",
                        function(t, e, n, i, r) {
                            return void 0 === r && (r = 1.70158), n * ((t = t / i - 1) * t * ((r + 1) * t + r) + 1) + e;
                        }
                    ],
                    "ease-in-out-back": [
                        "cubic-bezier(0.680, -0.550, 0.265, 1.550)",
                        function(t, e, n, i, r) {
                            return void 0 === r && (r = 1.70158), (t /= i / 2) < 1 ? n / 2 * t * t * (((r *= 1.525) + 1) * t - r) + e : n / 2 * ((t -= 2) * t * (((r *= 1.525) + 1) * t + r) + 2) + e;
                        }
                    ]
                }, f = {
                    "ease-in-back": "cubic-bezier(0.600, 0, 0.735, 0.045)",
                    "ease-out-back": "cubic-bezier(0.175, 0.885, 0.320, 1)",
                    "ease-in-out-back": "cubic-bezier(0.680, 0, 0.265, 1)"
                }, h = window, p = "bkwld-tram", v = /[\-\.0-9]/g, m = /[A-Z]/, g = "number", w = /^(rgb|#)/, b = /(em|cm|mm|in|pt|pc|px)$/, y = /(em|cm|mm|in|pt|pc|px|%)$/, x = /(deg|rad|turn)$/, k = "unitless", E = /(all|none) 0s ease 0s/, _ = /^(width|height)$/, A = document.createElement("a"), O = [
                    "Webkit",
                    "Moz",
                    "O",
                    "ms"
                ], R = [
                    "-webkit-",
                    "-moz-",
                    "-o-",
                    "-ms-"
                ], T = function(t) {
                    if (t in A.style) return {
                        dom: t,
                        css: t
                    };
                    var e, n, i = "", r = t.split("-");
                    for(e = 0; e < r.length; e++)i += r[e].charAt(0).toUpperCase() + r[e].slice(1);
                    for(e = 0; e < O.length; e++)if ((n = O[e] + i) in A.style) return {
                        dom: n,
                        css: R[e] + t
                    };
                }, C = e.support = {
                    bind: Function.prototype.bind,
                    transform: T("transform"),
                    transition: T("transition"),
                    backface: T("backface-visibility"),
                    timing: T("transition-timing-function")
                };
                if (C.transition) {
                    var L = C.timing.dom;
                    if (A.style[L] = d["ease-in-back"][0], !A.style[L]) for(var I in f)d[I][0] = f[I];
                }
                var D = e.frame = (s = h.requestAnimationFrame || h.webkitRequestAnimationFrame || h.mozRequestAnimationFrame || h.oRequestAnimationFrame || h.msRequestAnimationFrame) && C.bind ? s.bind(h) : function(t) {
                    h.setTimeout(t, 16);
                }, N = e.now = (c = (u = h.performance) && (u.now || u.webkitNow || u.msNow || u.mozNow)) && C.bind ? c.bind(u) : Date.now || function() {
                    return +new Date;
                }, z = l(function(e) {
                    function n(t, e) {
                        var n = function(t) {
                            for(var e = -1, n = t ? t.length : 0, i = []; ++e < n;){
                                var r = t[e];
                                r && i.push(r);
                            }
                            return i;
                        }(("" + t).split(" ")), i = n[0];
                        e = e || {};
                        var r = Z[i];
                        if (!r) return a("Unsupported property: " + i);
                        if (!e.weak || !this.props[i]) {
                            var o = r[0], s = this.props[i];
                            return s || (s = this.props[i] = new o.Bare), s.init(this.$el, n, r, e), s;
                        }
                    }
                    function i(t, e, i) {
                        if (t) {
                            var a = typeof t;
                            if (e || (this.timer && this.timer.destroy(), this.queue = [], this.active = !1), "number" == a && e) return this.timer = new H({
                                duration: t,
                                context: this,
                                complete: r
                            }), void (this.active = !0);
                            if ("string" == a && e) {
                                switch(t){
                                    case "hide":
                                        u.call(this);
                                        break;
                                    case "stop":
                                        s.call(this);
                                        break;
                                    case "redraw":
                                        c.call(this);
                                        break;
                                    default:
                                        n.call(this, t, i && i[1]);
                                }
                                return r.call(this);
                            }
                            if ("function" == a) return void t.call(this, this);
                            if ("object" == a) {
                                var f = 0;
                                d.call(this, t, function(t, e) {
                                    t.span > f && (f = t.span), t.stop(), t.animate(e);
                                }, function(t) {
                                    "wait" in t && (f = o(t.wait, 0));
                                }), l.call(this), f > 0 && (this.timer = new H({
                                    duration: f,
                                    context: this
                                }), this.active = !0, e && (this.timer.complete = r));
                                var h = this, p = !1, v = {};
                                D(function() {
                                    d.call(h, t, function(t) {
                                        t.active && (p = !0, v[t.name] = t.nextStyle);
                                    }), p && h.$el.css(v);
                                });
                            }
                        }
                    }
                    function r() {
                        if (this.timer && this.timer.destroy(), this.active = !1, this.queue.length) {
                            var t = this.queue.shift();
                            i.call(this, t.options, !0, t.args);
                        }
                    }
                    function s(t) {
                        var e;
                        this.timer && this.timer.destroy(), this.queue = [], this.active = !1, "string" == typeof t ? (e = {})[t] = 1 : e = "object" == typeof t && null != t ? t : this.props, d.call(this, e, f), l.call(this);
                    }
                    function u() {
                        s.call(this), this.el.style.display = "none";
                    }
                    function c() {
                        this.el.offsetHeight;
                    }
                    function l() {
                        var t, e, n = [];
                        for(t in this.upstream && n.push(this.upstream), this.props)(e = this.props[t]).active && n.push(e.string);
                        n = n.join(","), this.style !== n && (this.style = n, this.el.style[C.transition.dom] = n);
                    }
                    function d(t, e, i) {
                        var r, o, a, s, u = e !== f, c = {};
                        for(r in t)a = t[r], r in X ? (c.transform || (c.transform = {}), c.transform[r] = a) : (m.test(r) && (r = r.replace(/[A-Z]/g, function(t) {
                            return "-" + t.toLowerCase();
                        })), r in Z ? c[r] = a : (s || (s = {}), s[r] = a));
                        for(r in c){
                            if (a = c[r], !(o = this.props[r])) {
                                if (!u) continue;
                                o = n.call(this, r);
                            }
                            e.call(this, o, a);
                        }
                        i && s && i.call(this, s);
                    }
                    function f(t) {
                        t.stop();
                    }
                    function h(t, e) {
                        t.set(e);
                    }
                    function v(t) {
                        this.$el.css(t);
                    }
                    function g(t, n) {
                        e[t] = function() {
                            return this.children ? w.call(this, n, arguments) : (this.el && n.apply(this, arguments), this);
                        };
                    }
                    function w(t, e) {
                        var n, i = this.children.length;
                        for(n = 0; i > n; n++)t.apply(this.children[n], e);
                        return this;
                    }
                    e.init = function(e) {
                        if (this.$el = t(e), this.el = this.$el[0], this.props = {}, this.queue = [], this.style = "", this.active = !1, F.keepInherited && !F.fallback) {
                            var n = B(this.el, "transition");
                            n && !E.test(n) && (this.upstream = n);
                        }
                        C.backface && F.hideBackface && U(this.el, C.backface.css, "hidden");
                    }, g("add", n), g("start", i), g("wait", function(t) {
                        t = o(t, 0), this.active ? this.queue.push({
                            options: t
                        }) : (this.timer = new H({
                            duration: t,
                            context: this,
                            complete: r
                        }), this.active = !0);
                    }), g("then", function(t) {
                        return this.active ? (this.queue.push({
                            options: t,
                            args: arguments
                        }), void (this.timer.complete = r)) : a("No active transition timer. Use start() or wait() before then().");
                    }), g("next", r), g("stop", s), g("set", function(t) {
                        s.call(this, t), d.call(this, t, h, v);
                    }), g("show", function(t) {
                        "string" != typeof t && (t = "block"), this.el.style.display = t;
                    }), g("hide", u), g("redraw", c), g("destroy", function() {
                        s.call(this), t.removeData(this.el, p), this.$el = this.el = null;
                    });
                }), M = l(z, function(e) {
                    function n(e, n) {
                        var i = t.data(e, p) || t.data(e, p, new z.Bare);
                        return i.el || i.init(e), n ? i.start(n) : i;
                    }
                    e.init = function(e, i) {
                        var r = t(e);
                        if (!r.length) return this;
                        if (1 === r.length) return n(r[0], i);
                        var o = [];
                        return r.each(function(t, e) {
                            o.push(n(e, i));
                        }), this.children = o, this;
                    };
                }), P = l(function(t) {
                    function e() {
                        var t = this.get();
                        this.update("auto");
                        var e = this.get();
                        return this.update(t), e;
                    }
                    t.init = function(t, e, n, i) {
                        this.$el = t, this.el = t[0];
                        var r, a, s, u = e[0];
                        n[2] && (u = n[2]), G[u] && (u = G[u]), this.name = u, this.type = n[1], this.duration = o(e[1], this.duration, 500), this.ease = (r = e[2], a = this.ease, s = "ease", void 0 !== a && (s = a), r in d ? r : s), this.delay = o(e[3], this.delay, 0), this.span = this.duration + this.delay, this.active = !1, this.nextStyle = null, this.auto = _.test(this.name), this.unit = i.unit || this.unit || F.defaultUnit, this.angle = i.angle || this.angle || F.defaultAngle, F.fallback || i.fallback ? this.animate = this.fallback : (this.animate = this.transition, this.string = this.name + " " + this.duration + "ms" + ("ease" != this.ease ? " " + d[this.ease][0] : "") + (this.delay ? " " + this.delay + "ms" : ""));
                    }, t.set = function(t) {
                        t = this.convert(t, this.type), this.update(t), this.redraw();
                    }, t.transition = function(t) {
                        this.active = !0, t = this.convert(t, this.type), this.auto && ("auto" == this.el.style[this.name] && (this.update(this.get()), this.redraw()), "auto" == t && (t = e.call(this))), this.nextStyle = t;
                    }, t.fallback = function(t) {
                        var n = this.el.style[this.name] || this.convert(this.get(), this.type);
                        t = this.convert(t, this.type), this.auto && ("auto" == n && (n = this.convert(this.get(), this.type)), "auto" == t && (t = e.call(this))), this.tween = new q({
                            from: n,
                            to: t,
                            duration: this.duration,
                            delay: this.delay,
                            ease: this.ease,
                            update: this.update,
                            context: this
                        });
                    }, t.get = function() {
                        return B(this.el, this.name);
                    }, t.update = function(t) {
                        U(this.el, this.name, t);
                    }, t.stop = function() {
                        (this.active || this.nextStyle) && (this.active = !1, this.nextStyle = null, U(this.el, this.name, this.get()));
                        var t = this.tween;
                        t && t.context && t.destroy();
                    }, t.convert = function(t, e) {
                        if ("auto" == t && this.auto) return t;
                        var n, r, o = "number" == typeof t, s = "string" == typeof t;
                        switch(e){
                            case g:
                                if (o) return t;
                                if (s && "" === t.replace(v, "")) return +t;
                                r = "number(unitless)";
                                break;
                            case w:
                                if (s) {
                                    if ("" === t && this.original) return this.original;
                                    if (e.test(t)) return "#" == t.charAt(0) && 7 == t.length ? t : ((n = /rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(t)) ? i(n[1], n[2], n[3]) : t).replace(/#(\w)(\w)(\w)$/, "#$1$1$2$2$3$3");
                                }
                                r = "hex or rgb string";
                                break;
                            case b:
                                if (o) return t + this.unit;
                                if (s && e.test(t)) return t;
                                r = "number(px) or string(unit)";
                                break;
                            case y:
                                if (o) return t + this.unit;
                                if (s && e.test(t)) return t;
                                r = "number(px) or string(unit or %)";
                                break;
                            case x:
                                if (o) return t + this.angle;
                                if (s && e.test(t)) return t;
                                r = "number(deg) or string(angle)";
                                break;
                            case k:
                                if (o || s && y.test(t)) return t;
                                r = "number(unitless) or string(unit or %)";
                        }
                        return a("Type warning: Expected: [" + r + "] Got: [" + typeof t + "] " + t), t;
                    }, t.redraw = function() {
                        this.el.offsetHeight;
                    };
                }), $ = l(P, function(t, e) {
                    t.init = function() {
                        e.init.apply(this, arguments), this.original || (this.original = this.convert(this.get(), w));
                    };
                }), W = l(P, function(t, e) {
                    t.init = function() {
                        e.init.apply(this, arguments), this.animate = this.fallback;
                    }, t.get = function() {
                        return this.$el[this.name]();
                    }, t.update = function(t) {
                        this.$el[this.name](t);
                    };
                }), S = l(P, function(t, e) {
                    function n(t, e) {
                        var n, i, r, o, a;
                        for(n in t)r = (o = X[n])[0], i = o[1] || n, a = this.convert(t[n], r), e.call(this, i, a, r);
                    }
                    t.init = function() {
                        e.init.apply(this, arguments), this.current || (this.current = {}, X.perspective && F.perspective && (this.current.perspective = F.perspective, U(this.el, this.name, this.style(this.current)), this.redraw()));
                    }, t.set = function(t) {
                        n.call(this, t, function(t, e) {
                            this.current[t] = e;
                        }), U(this.el, this.name, this.style(this.current)), this.redraw();
                    }, t.transition = function(t) {
                        var e = this.values(t);
                        this.tween = new j({
                            current: this.current,
                            values: e,
                            duration: this.duration,
                            delay: this.delay,
                            ease: this.ease
                        });
                        var n, i = {};
                        for(n in this.current)i[n] = n in e ? e[n] : this.current[n];
                        this.active = !0, this.nextStyle = this.style(i);
                    }, t.fallback = function(t) {
                        var e = this.values(t);
                        this.tween = new j({
                            current: this.current,
                            values: e,
                            duration: this.duration,
                            delay: this.delay,
                            ease: this.ease,
                            update: this.update,
                            context: this
                        });
                    }, t.update = function() {
                        U(this.el, this.name, this.style(this.current));
                    }, t.style = function(t) {
                        var e, n = "";
                        for(e in t)n += e + "(" + t[e] + ") ";
                        return n;
                    }, t.values = function(t) {
                        var e, i = {};
                        return n.call(this, t, function(t, n, r) {
                            i[t] = n, void 0 === this.current[t] && (e = 0, ~t.indexOf("scale") && (e = 1), this.current[t] = this.convert(e, r));
                        }), i;
                    };
                }), q = l(function(e) {
                    function o() {
                        var t, e, n, i = u.length;
                        if (i) for(D(o), e = N(), t = i; t--;)(n = u[t]) && n.render(e);
                    }
                    var s = {
                        ease: d.ease[1],
                        from: 0,
                        to: 1
                    };
                    e.init = function(t) {
                        this.duration = t.duration || 0, this.delay = t.delay || 0;
                        var e = t.ease || s.ease;
                        d[e] && (e = d[e][1]), "function" != typeof e && (e = s.ease), this.ease = e, this.update = t.update || r, this.complete = t.complete || r, this.context = t.context || this, this.name = t.name;
                        var n = t.from, i = t.to;
                        void 0 === n && (n = s.from), void 0 === i && (i = s.to), this.unit = t.unit || "", "number" == typeof n && "number" == typeof i ? (this.begin = n, this.change = i - n) : this.format(i, n), this.value = this.begin + this.unit, this.start = N(), !1 !== t.autoplay && this.play();
                    }, e.play = function() {
                        this.active || (this.start || (this.start = N()), this.active = !0, 1 === u.push(this) && D(o));
                    }, e.stop = function() {
                        var e, n;
                        this.active && (this.active = !1, (n = t.inArray(this, u)) >= 0 && (e = u.slice(n + 1), u.length = n, e.length && (u = u.concat(e))));
                    }, e.render = function(t) {
                        var e, n = t - this.start;
                        if (this.delay) {
                            if (n <= this.delay) return;
                            n -= this.delay;
                        }
                        if (n < this.duration) {
                            var r, o, a = this.ease(n, 0, 1, this.duration);
                            return e = this.startRGB ? (r = this.startRGB, o = this.endRGB, i(r[0] + a * (o[0] - r[0]), r[1] + a * (o[1] - r[1]), r[2] + a * (o[2] - r[2]))) : Math.round((this.begin + a * this.change) * c) / c, this.value = e + this.unit, void this.update.call(this.context, this.value);
                        }
                        e = this.endHex || this.begin + this.change, this.value = e + this.unit, this.update.call(this.context, this.value), this.complete.call(this.context), this.destroy();
                    }, e.format = function(t, e) {
                        if (e += "", "#" == (t += "").charAt(0)) return this.startRGB = n(e), this.endRGB = n(t), this.endHex = t, this.begin = 0, void (this.change = 1);
                        if (!this.unit) {
                            var i = e.replace(v, "");
                            i !== t.replace(v, "") && a("Units do not match [tween]: " + e + ", " + t), this.unit = i;
                        }
                        e = parseFloat(e), t = parseFloat(t), this.begin = this.value = e, this.change = t - e;
                    }, e.destroy = function() {
                        this.stop(), this.context = null, this.ease = this.update = this.complete = r;
                    };
                    var u = [], c = 1e3;
                }), H = l(q, function(t) {
                    t.init = function(t) {
                        this.duration = t.duration || 0, this.complete = t.complete || r, this.context = t.context, this.play();
                    }, t.render = function(t) {
                        t - this.start < this.duration || (this.complete.call(this.context), this.destroy());
                    };
                }), j = l(q, function(t, e) {
                    t.init = function(t) {
                        var e, n;
                        for(e in this.context = t.context, this.update = t.update, this.tweens = [], this.current = t.current, t.values)n = t.values[e], this.current[e] !== n && this.tweens.push(new q({
                            name: e,
                            from: this.current[e],
                            to: n,
                            duration: t.duration,
                            delay: t.delay,
                            ease: t.ease,
                            autoplay: !1
                        }));
                        this.play();
                    }, t.render = function(t) {
                        var e, n, i = this.tweens.length, r = !1;
                        for(e = i; e--;)(n = this.tweens[e]).context && (n.render(t), this.current[n.name] = n.value, r = !0);
                        return r ? void (this.update && this.update.call(this.context)) : this.destroy();
                    }, t.destroy = function() {
                        if (e.destroy.call(this), this.tweens) {
                            var t;
                            for(t = this.tweens.length; t--;)this.tweens[t].destroy();
                            this.tweens = null, this.current = null;
                        }
                    };
                }), F = e.config = {
                    debug: !1,
                    defaultUnit: "px",
                    defaultAngle: "deg",
                    keepInherited: !1,
                    hideBackface: !1,
                    perspective: "",
                    fallback: !C.transition,
                    agentTests: []
                };
                e.fallback = function(t) {
                    if (!C.transition) return F.fallback = !0;
                    F.agentTests.push("(" + t + ")");
                    var e = RegExp(F.agentTests.join("|"), "i");
                    F.fallback = e.test(navigator.userAgent);
                }, e.fallback("6.0.[2-5] Safari"), e.tween = function(t) {
                    return new q(t);
                }, e.delay = function(t, e, n) {
                    return new H({
                        complete: e,
                        duration: t,
                        context: n
                    });
                }, t.fn.tram = function(t) {
                    return e.call(null, this, t);
                };
                var U = t.style, B = t.css, G = {
                    transform: C.transform && C.transform.css
                }, Z = {
                    color: [
                        $,
                        w
                    ],
                    background: [
                        $,
                        w,
                        "background-color"
                    ],
                    "outline-color": [
                        $,
                        w
                    ],
                    "border-color": [
                        $,
                        w
                    ],
                    "border-top-color": [
                        $,
                        w
                    ],
                    "border-right-color": [
                        $,
                        w
                    ],
                    "border-bottom-color": [
                        $,
                        w
                    ],
                    "border-left-color": [
                        $,
                        w
                    ],
                    "border-width": [
                        P,
                        b
                    ],
                    "border-top-width": [
                        P,
                        b
                    ],
                    "border-right-width": [
                        P,
                        b
                    ],
                    "border-bottom-width": [
                        P,
                        b
                    ],
                    "border-left-width": [
                        P,
                        b
                    ],
                    "border-spacing": [
                        P,
                        b
                    ],
                    "letter-spacing": [
                        P,
                        b
                    ],
                    margin: [
                        P,
                        b
                    ],
                    "margin-top": [
                        P,
                        b
                    ],
                    "margin-right": [
                        P,
                        b
                    ],
                    "margin-bottom": [
                        P,
                        b
                    ],
                    "margin-left": [
                        P,
                        b
                    ],
                    padding: [
                        P,
                        b
                    ],
                    "padding-top": [
                        P,
                        b
                    ],
                    "padding-right": [
                        P,
                        b
                    ],
                    "padding-bottom": [
                        P,
                        b
                    ],
                    "padding-left": [
                        P,
                        b
                    ],
                    "outline-width": [
                        P,
                        b
                    ],
                    opacity: [
                        P,
                        g
                    ],
                    top: [
                        P,
                        y
                    ],
                    right: [
                        P,
                        y
                    ],
                    bottom: [
                        P,
                        y
                    ],
                    left: [
                        P,
                        y
                    ],
                    "font-size": [
                        P,
                        y
                    ],
                    "text-indent": [
                        P,
                        y
                    ],
                    "word-spacing": [
                        P,
                        y
                    ],
                    width: [
                        P,
                        y
                    ],
                    "min-width": [
                        P,
                        y
                    ],
                    "max-width": [
                        P,
                        y
                    ],
                    height: [
                        P,
                        y
                    ],
                    "min-height": [
                        P,
                        y
                    ],
                    "max-height": [
                        P,
                        y
                    ],
                    "line-height": [
                        P,
                        k
                    ],
                    "scroll-top": [
                        W,
                        g,
                        "scrollTop"
                    ],
                    "scroll-left": [
                        W,
                        g,
                        "scrollLeft"
                    ]
                }, X = {};
                C.transform && (Z.transform = [
                    S
                ], X = {
                    x: [
                        y,
                        "translateX"
                    ],
                    y: [
                        y,
                        "translateY"
                    ],
                    rotate: [
                        x
                    ],
                    rotateX: [
                        x
                    ],
                    rotateY: [
                        x
                    ],
                    scale: [
                        g
                    ],
                    scaleX: [
                        g
                    ],
                    scaleY: [
                        g
                    ],
                    skew: [
                        x
                    ],
                    skewX: [
                        x
                    ],
                    skewY: [
                        x
                    ]
                }), C.transform && C.backface && (X.z = [
                    y,
                    "translateZ"
                ], X.rotateZ = [
                    x
                ], X.scaleZ = [
                    g
                ], X.perspective = [
                    b
                ]);
                var Y = /ms/, K = /s|\./;
                return t.tram = e;
            }(window.jQuery);
        },
        756: function(t, e, n) {
            "use strict";
            var i, r, o, a, s, u, c, l, d, f, h, p, v, m, g, w, b, y, x, k, E = window.$, _ = n(487) && E.tram;
            (i = {}).VERSION = "1.6.0-Webflow", r = {}, o = Array.prototype, a = Object.prototype, s = Function.prototype, o.push, u = o.slice, o.concat, a.toString, c = a.hasOwnProperty, l = o.forEach, d = o.map, o.reduce, o.reduceRight, f = o.filter, o.every, h = o.some, p = o.indexOf, o.lastIndexOf, v = Object.keys, s.bind, m = i.each = i.forEach = function(t, e, n) {
                if (null == t) return t;
                if (l && t.forEach === l) t.forEach(e, n);
                else if (t.length === +t.length) {
                    for(var o = 0, a = t.length; o < a; o++)if (e.call(n, t[o], o, t) === r) return;
                } else for(var s = i.keys(t), o = 0, a = s.length; o < a; o++)if (e.call(n, t[s[o]], s[o], t) === r) return;
                return t;
            }, i.map = i.collect = function(t, e, n) {
                var i = [];
                return null == t ? i : d && t.map === d ? t.map(e, n) : (m(t, function(t, r, o) {
                    i.push(e.call(n, t, r, o));
                }), i);
            }, i.find = i.detect = function(t, e, n) {
                var i;
                return g(t, function(t, r, o) {
                    if (e.call(n, t, r, o)) return i = t, !0;
                }), i;
            }, i.filter = i.select = function(t, e, n) {
                var i = [];
                return null == t ? i : f && t.filter === f ? t.filter(e, n) : (m(t, function(t, r, o) {
                    e.call(n, t, r, o) && i.push(t);
                }), i);
            }, g = i.some = i.any = function(t, e, n) {
                e || (e = i.identity);
                var o = !1;
                return null == t ? o : h && t.some === h ? t.some(e, n) : (m(t, function(t, i, a) {
                    if (o || (o = e.call(n, t, i, a))) return r;
                }), !!o);
            }, i.contains = i.include = function(t, e) {
                return null != t && (p && t.indexOf === p ? -1 != t.indexOf(e) : g(t, function(t) {
                    return t === e;
                }));
            }, i.delay = function(t, e) {
                var n = u.call(arguments, 2);
                return setTimeout(function() {
                    return t.apply(null, n);
                }, e);
            }, i.defer = function(t) {
                return i.delay.apply(i, [
                    t,
                    1
                ].concat(u.call(arguments, 1)));
            }, i.throttle = function(t) {
                var e, n, i;
                return function() {
                    e || (e = !0, n = arguments, i = this, _.frame(function() {
                        e = !1, t.apply(i, n);
                    }));
                };
            }, i.debounce = function(t, e, n) {
                var r, o, a, s, u, c = function() {
                    var l = i.now() - s;
                    l < e ? r = setTimeout(c, e - l) : (r = null, n || (u = t.apply(a, o), a = o = null));
                };
                return function() {
                    a = this, o = arguments, s = i.now();
                    var l = n && !r;
                    return r || (r = setTimeout(c, e)), l && (u = t.apply(a, o), a = o = null), u;
                };
            }, i.defaults = function(t) {
                if (!i.isObject(t)) return t;
                for(var e = 1, n = arguments.length; e < n; e++){
                    var r = arguments[e];
                    for(var o in r)void 0 === t[o] && (t[o] = r[o]);
                }
                return t;
            }, i.keys = function(t) {
                if (!i.isObject(t)) return [];
                if (v) return v(t);
                var e = [];
                for(var n in t)i.has(t, n) && e.push(n);
                return e;
            }, i.has = function(t, e) {
                return c.call(t, e);
            }, i.isObject = function(t) {
                return t === Object(t);
            }, i.now = Date.now || function() {
                return new Date().getTime();
            }, i.templateSettings = {
                evaluate: /<%([\s\S]+?)%>/g,
                interpolate: /<%=([\s\S]+?)%>/g,
                escape: /<%-([\s\S]+?)%>/g
            }, w = /(.)^/, b = {
                "'": "'",
                "\\": "\\",
                "\r": "r",
                "\n": "n",
                "\u2028": "u2028",
                "\u2029": "u2029"
            }, y = /\\|'|\r|\n|\u2028|\u2029/g, x = function(t) {
                return "\\" + b[t];
            }, k = /^\s*(\w|\$)+\s*$/, i.template = function(t, e, n) {
                !e && n && (e = n);
                var r, o = RegExp([
                    ((e = i.defaults({}, e, i.templateSettings)).escape || w).source,
                    (e.interpolate || w).source,
                    (e.evaluate || w).source
                ].join("|") + "|$", "g"), a = 0, s = "__p+='";
                t.replace(o, function(e, n, i, r, o) {
                    return s += t.slice(a, o).replace(y, x), a = o + e.length, n ? s += "'+\n((__t=(" + n + "))==null?'':_.escape(__t))+\n'" : i ? s += "'+\n((__t=(" + i + "))==null?'':__t)+\n'" : r && (s += "';\n" + r + "\n__p+='"), e;
                }), s += "';\n";
                var u = e.variable;
                if (u) {
                    if (!k.test(u)) throw Error("variable is not a bare identifier: " + u);
                } else s = "with(obj||{}){\n" + s + "}\n", u = "obj";
                s = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + s + "return __p;\n";
                try {
                    r = Function(e.variable || "obj", "_", s);
                } catch (t) {
                    throw t.source = s, t;
                }
                var c = function(t) {
                    return r.call(this, t, i);
                };
                return c.source = "function(" + u + "){\n" + s + "}", c;
            }, t.exports = i;
        },
        461: function(t, e, n) {
            "use strict";
            var i = n(949);
            i.define("brand", t.exports = function(t) {
                var e, n = {}, r = document, o = t("html"), a = t("body"), s = window.location, u = /PhantomJS/i.test(navigator.userAgent), c = "fullscreenchange webkitfullscreenchange mozfullscreenchange msfullscreenchange";
                function l() {
                    var n = r.fullScreen || r.mozFullScreen || r.webkitIsFullScreen || r.msFullscreenElement || !!r.webkitFullscreenElement;
                    t(e).attr("style", n ? "display: none !important;" : "");
                }
                function d() {
                    var t = a.children(".w-webflow-badge"), n = t.length && t.get(0) === e, r = i.env("editor");
                    if (n) {
                        r && t.remove();
                        return;
                    }
                    t.length && t.remove(), r || a.append(e);
                }
                return n.ready = function() {
                    var n, i, a, f = o.attr("data-wf-status"), h = o.attr("data-wf-domain") || "";
                    /\.webflow\.io$/i.test(h) && s.hostname !== h && (f = !0), f && !u && (e = e || (n = t('<a class="w-webflow-badge"></a>').attr("href", "https://webflow.com?utm_campaign=brandjs"), i = t("<img>").attr("src", "https://d3e54v103j8qbb.cloudfront.net/img/webflow-badge-icon-d2.89e12c322e.svg").attr("alt", "").css({
                        marginRight: "4px",
                        width: "26px"
                    }), a = t("<img>").attr("src", "https://d3e54v103j8qbb.cloudfront.net/img/webflow-badge-text-d2.c82cec3b78.svg").attr("alt", "Made in Webflow"), n.append(i, a), n[0]), d(), setTimeout(d, 500), t(r).off(c, l).on(c, l));
                }, n;
            });
        },
        338: function(t, e, n) {
            "use strict";
            n(949).define("focus-visible", t.exports = function() {
                return {
                    ready: function() {
                        if ("undefined" != typeof document) try {
                            document.querySelector(":focus-visible");
                        } catch (t) {
                            !function(t) {
                                var e = !0, n = !1, i = null, r = {
                                    text: !0,
                                    search: !0,
                                    url: !0,
                                    tel: !0,
                                    email: !0,
                                    password: !0,
                                    number: !0,
                                    date: !0,
                                    month: !0,
                                    week: !0,
                                    time: !0,
                                    datetime: !0,
                                    "datetime-local": !0
                                };
                                function o(t) {
                                    return !!t && t !== document && "HTML" !== t.nodeName && "BODY" !== t.nodeName && "classList" in t && "contains" in t.classList;
                                }
                                function a(t) {
                                    t.getAttribute("data-wf-focus-visible") || t.setAttribute("data-wf-focus-visible", "true");
                                }
                                function s() {
                                    e = !1;
                                }
                                function u() {
                                    document.addEventListener("mousemove", c), document.addEventListener("mousedown", c), document.addEventListener("mouseup", c), document.addEventListener("pointermove", c), document.addEventListener("pointerdown", c), document.addEventListener("pointerup", c), document.addEventListener("touchmove", c), document.addEventListener("touchstart", c), document.addEventListener("touchend", c);
                                }
                                function c(t) {
                                    t.target.nodeName && "html" === t.target.nodeName.toLowerCase() || (e = !1, document.removeEventListener("mousemove", c), document.removeEventListener("mousedown", c), document.removeEventListener("mouseup", c), document.removeEventListener("pointermove", c), document.removeEventListener("pointerdown", c), document.removeEventListener("pointerup", c), document.removeEventListener("touchmove", c), document.removeEventListener("touchstart", c), document.removeEventListener("touchend", c));
                                }
                                document.addEventListener("keydown", function(n) {
                                    n.metaKey || n.altKey || n.ctrlKey || (o(t.activeElement) && a(t.activeElement), e = !0);
                                }, !0), document.addEventListener("mousedown", s, !0), document.addEventListener("pointerdown", s, !0), document.addEventListener("touchstart", s, !0), document.addEventListener("visibilitychange", function() {
                                    "hidden" === document.visibilityState && (n && (e = !0), u());
                                }, !0), u(), t.addEventListener("focus", function(t) {
                                    if (o(t.target)) {
                                        var n, i, s;
                                        (e || (i = (n = t.target).type, "INPUT" === (s = n.tagName) && r[i] && !n.readOnly || "TEXTAREA" === s && !n.readOnly || n.isContentEditable || 0)) && a(t.target);
                                    }
                                }, !0), t.addEventListener("blur", function(t) {
                                    if (o(t.target) && t.target.hasAttribute("data-wf-focus-visible")) {
                                        var e;
                                        n = !0, window.clearTimeout(i), i = window.setTimeout(function() {
                                            n = !1;
                                        }, 100), (e = t.target).getAttribute("data-wf-focus-visible") && e.removeAttribute("data-wf-focus-visible");
                                    }
                                }, !0);
                            }(document);
                        }
                    }
                };
            });
        },
        334: function(t, e, n) {
            "use strict";
            var i = n(949);
            i.define("focus", t.exports = function() {
                var t = [], e = !1;
                function n(n) {
                    e && (n.preventDefault(), n.stopPropagation(), n.stopImmediatePropagation(), t.unshift(n));
                }
                function r(n) {
                    var i, r;
                    r = (i = n.target).tagName, (/^a$/i.test(r) && null != i.href || /^(button|textarea)$/i.test(r) && !0 !== i.disabled || /^input$/i.test(r) && /^(button|reset|submit|radio|checkbox)$/i.test(i.type) && !i.disabled || !/^(button|input|textarea|select|a)$/i.test(r) && !Number.isNaN(Number.parseFloat(i.tabIndex)) || /^audio$/i.test(r) || /^video$/i.test(r) && !0 === i.controls) && (e = !0, setTimeout(()=>{
                        for(e = !1, n.target.focus(); t.length > 0;){
                            var i = t.pop();
                            i.target.dispatchEvent(new MouseEvent(i.type, i));
                        }
                    }, 0));
                }
                return {
                    ready: function() {
                        "undefined" != typeof document && document.body.hasAttribute("data-wf-focus-within") && i.env.safari && (document.addEventListener("mousedown", r, !0), document.addEventListener("mouseup", n, !0), document.addEventListener("click", n, !0));
                    }
                };
            });
        },
        199: function(t) {
            "use strict";
            var e = window.jQuery, n = {}, i = [], r = ".w-ix", o = {
                reset: function(t, e) {
                    e.__wf_intro = null;
                },
                intro: function(t, i) {
                    i.__wf_intro || (i.__wf_intro = !0, e(i).triggerHandler(n.types.INTRO));
                },
                outro: function(t, i) {
                    i.__wf_intro && (i.__wf_intro = null, e(i).triggerHandler(n.types.OUTRO));
                }
            };
            n.triggers = {}, n.types = {
                INTRO: "w-ix-intro" + r,
                OUTRO: "w-ix-outro" + r
            }, n.init = function() {
                for(var t = i.length, r = 0; r < t; r++){
                    var a = i[r];
                    a[0](0, a[1]);
                }
                i = [], e.extend(n.triggers, o);
            }, n.async = function() {
                for(var t in o){
                    var e = o[t];
                    o.hasOwnProperty(t) && (n.triggers[t] = function(t, n) {
                        i.push([
                            e,
                            n
                        ]);
                    });
                }
            }, n.async(), t.exports = n;
        },
        134: function(t, e, n) {
            "use strict";
            var i = n(199);
            function r(t, e) {
                var n = document.createEvent("CustomEvent");
                n.initCustomEvent(e, !0, !0, null), t.dispatchEvent(n);
            }
            var o = window.jQuery, a = {}, s = ".w-ix";
            a.triggers = {}, a.types = {
                INTRO: "w-ix-intro" + s,
                OUTRO: "w-ix-outro" + s
            }, o.extend(a.triggers, {
                reset: function(t, e) {
                    i.triggers.reset(t, e);
                },
                intro: function(t, e) {
                    i.triggers.intro(t, e), r(e, "COMPONENT_ACTIVE");
                },
                outro: function(t, e) {
                    i.triggers.outro(t, e), r(e, "COMPONENT_INACTIVE");
                }
            }), t.exports = a;
        },
        949: function(t, e, n) {
            "use strict";
            var i, r, o = {}, a = {}, s = [], u = window.Webflow || [], c = window.jQuery, l = c(window), d = c(document), f = c.isFunction, h = o._ = n(756), p = o.tram = n(487) && c.tram, v = !1, m = !1;
            function g(t) {
                o.env() && (f(t.design) && l.on("__wf_design", t.design), f(t.preview) && l.on("__wf_preview", t.preview)), f(t.destroy) && l.on("__wf_destroy", t.destroy), t.ready && f(t.ready) && function(t) {
                    if (v) return t.ready();
                    h.contains(s, t.ready) || s.push(t.ready);
                }(t);
            }
            function w(t) {
                var e;
                f(t.design) && l.off("__wf_design", t.design), f(t.preview) && l.off("__wf_preview", t.preview), f(t.destroy) && l.off("__wf_destroy", t.destroy), t.ready && f(t.ready) && (e = t, s = h.filter(s, function(t) {
                    return t !== e.ready;
                }));
            }
            p.config.hideBackface = !1, p.config.keepInherited = !0, o.define = function(t, e, n) {
                a[t] && w(a[t]);
                var i = a[t] = e(c, h, n) || {};
                return g(i), i;
            }, o.require = function(t) {
                return a[t];
            }, o.push = function(t) {
                if (v) {
                    f(t) && t();
                    return;
                }
                u.push(t);
            }, o.env = function(t) {
                var e = window.__wf_design, n = void 0 !== e;
                return t ? "design" === t ? n && e : "preview" === t ? n && !e : "slug" === t ? n && window.__wf_slug : "editor" === t ? window.WebflowEditor : "test" === t ? window.__wf_test : "frame" === t ? window !== window.top : void 0 : n;
            };
            var b = navigator.userAgent.toLowerCase(), y = o.env.touch = "ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch, x = o.env.chrome = /chrome/.test(b) && /Google/.test(navigator.vendor) && parseInt(b.match(/chrome\/(\d+)\./)[1], 10), k = o.env.ios = /(ipod|iphone|ipad)/.test(b);
            o.env.safari = /safari/.test(b) && !x && !k, y && d.on("touchstart mousedown", function(t) {
                i = t.target;
            }), o.validClick = y ? function(t) {
                return t === i || c.contains(t, i);
            } : function() {
                return !0;
            };
            var E = "resize.webflow orientationchange.webflow load.webflow", _ = "scroll.webflow " + E;
            function A(t, e) {
                var n = [], i = {};
                return i.up = h.throttle(function(t) {
                    h.each(n, function(e) {
                        e(t);
                    });
                }), t && e && t.on(e, i.up), i.on = function(t) {
                    "function" == typeof t && (h.contains(n, t) || n.push(t));
                }, i.off = function(t) {
                    if (!arguments.length) {
                        n = [];
                        return;
                    }
                    n = h.filter(n, function(e) {
                        return e !== t;
                    });
                }, i;
            }
            function O(t) {
                f(t) && t();
            }
            function R() {
                r && (r.reject(), l.off("load", r.resolve)), r = new c.Deferred, l.on("load", r.resolve);
            }
            o.resize = A(l, E), o.scroll = A(l, _), o.redraw = A(), o.location = function(t) {
                window.location = t;
            }, o.env() && (o.location = function() {}), o.ready = function() {
                v = !0, m ? (m = !1, h.each(a, g)) : h.each(s, O), h.each(u, O), o.resize.up();
            }, o.load = function(t) {
                r.then(t);
            }, o.destroy = function(t) {
                t = t || {}, m = !0, l.triggerHandler("__wf_destroy"), null != t.domready && (v = t.domready), h.each(a, w), o.resize.off(), o.scroll.off(), o.redraw.off(), s = [], u = [], "pending" === r.state() && R();
            }, c(o.ready), R(), t.exports = window.Webflow = o;
        },
        624: function(t, e, n) {
            "use strict";
            var i = n(949);
            i.define("links", t.exports = function(t, e) {
                var n, r, o, a = {}, s = t(window), u = i.env(), c = window.location, l = document.createElement("a"), d = "w--current", f = /index\.(html|php)$/, h = /\/$/;
                function p() {
                    var t = s.scrollTop(), n = s.height();
                    e.each(r, function(e) {
                        if (!e.link.attr("hreflang")) {
                            var i = e.link, r = e.sec, o = r.offset().top, a = r.outerHeight(), s = .5 * n, u = r.is(":visible") && o + a - s >= t && o + s <= t + n;
                            e.active !== u && (e.active = u, v(i, d, u));
                        }
                    });
                }
                function v(t, e, n) {
                    var i = t.hasClass(e);
                    (!n || !i) && (n || i) && (n ? t.addClass(e) : t.removeClass(e));
                }
                return a.ready = a.design = a.preview = function() {
                    n = u && i.env("design"), o = i.env("slug") || c.pathname || "", i.scroll.off(p), r = [];
                    for(var e = document.links, a = 0; a < e.length; ++a)!function(e) {
                        if (!e.getAttribute("hreflang")) {
                            var i = n && e.getAttribute("href-disabled") || e.getAttribute("href");
                            if (l.href = i, !(i.indexOf(":") >= 0)) {
                                var a = t(e);
                                if (l.hash.length > 1 && l.host + l.pathname === c.host + c.pathname) {
                                    if (!/^#[a-zA-Z0-9\-\_]+$/.test(l.hash)) return;
                                    var s = t(l.hash);
                                    s.length && r.push({
                                        link: a,
                                        sec: s,
                                        active: !1
                                    });
                                    return;
                                }
                                "#" !== i && "" !== i && v(a, d, !u && l.href === c.href || i === o || f.test(i) && h.test(o));
                            }
                        }
                    }(e[a]);
                    r.length && (i.scroll.on(p), p());
                }, a;
            });
        },
        286: function(t, e, n) {
            "use strict";
            var i = n(949);
            i.define("scroll", t.exports = function(t) {
                var e = {
                    WF_CLICK_EMPTY: "click.wf-empty-link",
                    WF_CLICK_SCROLL: "click.wf-scroll"
                }, n = window.location, r = !function() {
                    try {
                        return !!window.frameElement;
                    } catch (t) {
                        return !0;
                    }
                }() ? window.history : null, o = t(window), a = t(document), s = t(document.body), u = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(t) {
                    window.setTimeout(t, 15);
                }, c = i.env("editor") ? ".w-editor-body" : "body", l = "header, " + c + " > .header, " + c + " > .w-nav:not([data-no-scroll])", d = 'a[href="#"]', f = 'a[href*="#"]:not(.w-tab-link):not(' + d + ")", h = document.createElement("style");
                h.appendChild(document.createTextNode('.wf-force-outline-none[tabindex="-1"]:focus{outline:none;}'));
                var p = /^#[a-zA-Z0-9][\w:.-]*$/;
                let v = "function" == typeof window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");
                function m(t, e) {
                    var n;
                    switch(e){
                        case "add":
                            (n = t.attr("tabindex")) ? t.attr("data-wf-tabindex-swap", n) : t.attr("tabindex", "-1");
                            break;
                        case "remove":
                            (n = t.attr("data-wf-tabindex-swap")) ? (t.attr("tabindex", n), t.removeAttr("data-wf-tabindex-swap")) : t.removeAttr("tabindex");
                    }
                    t.toggleClass("wf-force-outline-none", "add" === e);
                }
                function g(e) {
                    var a = e.currentTarget;
                    if (!(i.env("design") || window.$.mobile && /(?:^|\s)ui-link(?:$|\s)/.test(a.className))) {
                        var c = p.test(a.hash) && a.host + a.pathname === n.host + n.pathname ? a.hash : "";
                        if ("" !== c) {
                            var d, f = t(c);
                            f.length && (e && (e.preventDefault(), e.stopPropagation()), d = c, n.hash !== d && r && r.pushState && !(i.env.chrome && "file:" === n.protocol) && (r.state && r.state.hash) !== d && r.pushState({
                                hash: d
                            }, "", d), window.setTimeout(function() {
                                !function(e, n) {
                                    var i = o.scrollTop(), r = function(e) {
                                        var n = t(l), i = "fixed" === n.css("position") ? n.outerHeight() : 0, r = e.offset().top - i;
                                        if ("mid" === e.data("scroll")) {
                                            var a = o.height() - i, s = e.outerHeight();
                                            s < a && (r -= Math.round((a - s) / 2));
                                        }
                                        return r;
                                    }(e);
                                    if (i !== r) {
                                        var a = function(t, e, n) {
                                            if ("none" === document.body.getAttribute("data-wf-scroll-motion") || v.matches) return 0;
                                            var i = 1;
                                            return s.add(t).each(function(t, e) {
                                                var n = parseFloat(e.getAttribute("data-scroll-time"));
                                                !isNaN(n) && n >= 0 && (i = n);
                                            }), (472.143 * Math.log(Math.abs(e - n) + 125) - 2e3) * i;
                                        }(e, i, r), c = Date.now(), d = function() {
                                            var t, e, o, s, l, f = Date.now() - c;
                                            window.scroll(0, (t = i, e = r, (o = f) > (s = a) ? e : t + (e - t) * ((l = o / s) < .5 ? 4 * l * l * l : (l - 1) * (2 * l - 2) * (2 * l - 2) + 1))), f <= a ? u(d) : "function" == typeof n && n();
                                        };
                                        u(d);
                                    }
                                }(f, function() {
                                    m(f, "add"), f.get(0).focus({
                                        preventScroll: !0
                                    }), m(f, "remove");
                                });
                            }, 300 * !e));
                        }
                    }
                }
                return {
                    ready: function() {
                        var { WF_CLICK_EMPTY: t, WF_CLICK_SCROLL: n } = e;
                        a.on(n, f, g), a.on(t, d, function(t) {
                            t.preventDefault();
                        }), document.head.insertBefore(h, document.head.firstChild);
                    }
                };
            });
        },
        695: function(t, e, n) {
            "use strict";
            n(949).define("touch", t.exports = function(t) {
                var e = {}, n = window.getSelection;
                function i(e) {
                    var i, r, o = !1, a = !1, s = Math.min(Math.round(.04 * window.innerWidth), 40);
                    function u(t) {
                        var e = t.touches;
                        e && e.length > 1 || (o = !0, e ? (a = !0, i = e[0].clientX) : i = t.clientX, r = i);
                    }
                    function c(e) {
                        if (o) {
                            if (a && "mousemove" === e.type) {
                                e.preventDefault(), e.stopPropagation();
                                return;
                            }
                            var i, u, c, l, f = e.touches, h = f ? f[0].clientX : e.clientX, p = h - r;
                            r = h, Math.abs(p) > s && n && "" === String(n()) && (i = "swipe", u = e, c = {
                                direction: p > 0 ? "right" : "left"
                            }, l = t.Event(i, {
                                originalEvent: u
                            }), t(u.target).trigger(l, c), d());
                        }
                    }
                    function l(t) {
                        if (o && (o = !1, a && "mouseup" === t.type)) {
                            t.preventDefault(), t.stopPropagation(), a = !1;
                            return;
                        }
                    }
                    function d() {
                        o = !1;
                    }
                    e.addEventListener("touchstart", u, !1), e.addEventListener("touchmove", c, !1), e.addEventListener("touchend", l, !1), e.addEventListener("touchcancel", d, !1), e.addEventListener("mousedown", u, !1), e.addEventListener("mousemove", c, !1), e.addEventListener("mouseup", l, !1), e.addEventListener("mouseout", d, !1), this.destroy = function() {
                        e.removeEventListener("touchstart", u, !1), e.removeEventListener("touchmove", c, !1), e.removeEventListener("touchend", l, !1), e.removeEventListener("touchcancel", d, !1), e.removeEventListener("mousedown", u, !1), e.removeEventListener("mousemove", c, !1), e.removeEventListener("mouseup", l, !1), e.removeEventListener("mouseout", d, !1), e = null;
                    };
                }
                return t.event.special.tap = {
                    bindType: "click",
                    delegateType: "click"
                }, e.init = function(e) {
                    return (e = "string" == typeof e ? t(e).get(0) : e) ? new i(e) : null;
                }, e.instance = e.init(document), e;
            });
        },
        858: function(t, e, n) {
            "use strict";
            var i = n(949), r = n(134);
            let o = {
                ARROW_LEFT: 37,
                ARROW_UP: 38,
                ARROW_RIGHT: 39,
                ARROW_DOWN: 40,
                ESCAPE: 27,
                SPACE: 32,
                ENTER: 13,
                HOME: 36,
                END: 35
            }, a = /^#[a-zA-Z0-9\-_]+$/;
            i.define("dropdown", t.exports = function(t, e) {
                var n, s, u = e.debounce, c = {}, l = i.env(), d = !1, f = i.env.touch, h = ".w-dropdown", p = "w--open", v = r.triggers, m = "focusout" + h, g = "keydown" + h, w = "mouseenter" + h, b = "mousemove" + h, y = "mouseleave" + h, x = (f ? "click" : "mouseup") + h, k = "w-close" + h, E = "setting" + h, _ = t(document);
                function A() {
                    n = l && i.env("design"), (s = _.find(h)).each(O);
                }
                function O(e, r) {
                    var s, c, d, f, v, b, y, A, O, D, N = t(r), z = t.data(r, h);
                    z || (z = t.data(r, h, {
                        open: !1,
                        el: N,
                        config: {},
                        selectedIdx: -1
                    })), z.toggle = z.el.children(".w-dropdown-toggle"), z.list = z.el.children(".w-dropdown-list"), z.links = z.list.find("a:not(.w-dropdown .w-dropdown a)"), z.complete = (s = z, function() {
                        s.list.removeClass(p), s.toggle.removeClass(p), s.manageZ && s.el.css("z-index", "");
                    }), z.mouseLeave = (c = z, function() {
                        c.hovering = !1, c.links.is(":focus") || L(c);
                    }), z.mouseUpOutside = ((d = z).mouseUpOutside && _.off(x, d.mouseUpOutside), u(function(e) {
                        if (d.open) {
                            var n = t(e.target);
                            if (!n.closest(".w-dropdown-toggle").length) {
                                var r = -1 === t.inArray(d.el[0], n.parents(h)), o = i.env("editor");
                                if (r) {
                                    if (o) {
                                        var a = 1 === n.parents().length && 1 === n.parents("svg").length, s = n.parents(".w-editor-bem-EditorHoverControls").length;
                                        if (a || s) return;
                                    }
                                    L(d);
                                }
                            }
                        }
                    })), z.mouseMoveOutside = (f = z, u(function(e) {
                        if (f.open) {
                            var n = t(e.target);
                            if (-1 === t.inArray(f.el[0], n.parents(h))) {
                                var i = n.parents(".w-editor-bem-EditorHoverControls").length, r = n.parents(".w-editor-bem-RTToolbar").length, o = t(".w-editor-bem-EditorOverlay"), a = o.find(".w-editor-edit-outline").length || o.find(".w-editor-bem-RTToolbar").length;
                                if (i || r || a) return;
                                f.hovering = !1, L(f);
                            }
                        }
                    })), R(z);
                    var M = z.toggle.attr("id"), P = z.list.attr("id");
                    M || (M = "w-dropdown-toggle-" + e), P || (P = "w-dropdown-list-" + e), z.toggle.attr("id", M), z.toggle.attr("aria-controls", P), z.toggle.attr("aria-haspopup", "menu"), z.toggle.attr("aria-expanded", "false"), z.toggle.find(".w-icon-dropdown-toggle").attr("aria-hidden", "true"), "BUTTON" !== z.toggle.prop("tagName") && (z.toggle.attr("role", "button"), z.toggle.attr("tabindex") || z.toggle.attr("tabindex", "0")), z.list.attr("id", P), z.list.attr("aria-labelledby", M), z.links.each(function(t, e) {
                        e.hasAttribute("tabindex") || e.setAttribute("tabindex", "0"), a.test(e.hash) && e.addEventListener("click", L.bind(null, z));
                    }), z.el.off(h), z.toggle.off(h), z.nav && z.nav.off(h);
                    var $ = T(z, !0);
                    n && z.el.on(E, (v = z, function(t, e) {
                        e = e || {}, R(v), !0 === e.open && C(v), !1 === e.open && L(v, {
                            immediate: !0
                        });
                    })), n || (l && (z.hovering = !1, L(z)), z.config.hover && z.toggle.on(w, (b = z, function() {
                        b.hovering = !0, C(b);
                    })), z.el.on(k, $), z.el.on(g, (y = z, function(t) {
                        if (!n && y.open) switch(y.selectedIdx = y.links.index(document.activeElement), t.keyCode){
                            case o.HOME:
                                if (!y.open) return;
                                return y.selectedIdx = 0, I(y), t.preventDefault();
                            case o.END:
                                if (!y.open) return;
                                return y.selectedIdx = y.links.length - 1, I(y), t.preventDefault();
                            case o.ESCAPE:
                                return L(y), y.toggle.focus(), t.stopPropagation();
                            case o.ARROW_RIGHT:
                            case o.ARROW_DOWN:
                                return y.selectedIdx = Math.min(y.links.length - 1, y.selectedIdx + 1), I(y), t.preventDefault();
                            case o.ARROW_LEFT:
                            case o.ARROW_UP:
                                return y.selectedIdx = Math.max(-1, y.selectedIdx - 1), I(y), t.preventDefault();
                        }
                    })), z.el.on(m, (A = z, u(function(t) {
                        var { relatedTarget: e, target: n } = t, i = A.el[0];
                        return i.contains(e) || i.contains(n) || L(A), t.stopPropagation();
                    }))), z.toggle.on(x, $), z.toggle.on(g, (D = T(O = z, !0), function(t) {
                        if (!n) {
                            if (!O.open) switch(t.keyCode){
                                case o.ARROW_UP:
                                case o.ARROW_DOWN:
                                    return t.stopPropagation();
                            }
                            switch(t.keyCode){
                                case o.SPACE:
                                case o.ENTER:
                                    return D(), t.stopPropagation(), t.preventDefault();
                            }
                        }
                    })), z.nav = z.el.closest(".w-nav"), z.nav.on(k, $));
                }
                function R(t) {
                    var e = Number(t.el.css("z-index"));
                    t.manageZ = 900 === e || 901 === e, t.config = {
                        hover: "true" === t.el.attr("data-hover") && !f,
                        delay: t.el.attr("data-delay")
                    };
                }
                function T(t, e) {
                    return u(function(n) {
                        if (t.open || n && "w-close" === n.type) return L(t, {
                            forceClose: e
                        });
                        C(t);
                    });
                }
                function C(e) {
                    if (!e.open) {
                        r = e.el[0], s.each(function(e, n) {
                            var i = t(n);
                            i.is(r) || i.has(r).length || i.triggerHandler(k);
                        }), e.open = !0, e.list.addClass(p), e.toggle.addClass(p), e.toggle.attr("aria-expanded", "true"), v.intro(0, e.el[0]), i.redraw.up(), e.manageZ && e.el.css("z-index", 901);
                        var r, o = i.env("editor");
                        n || _.on(x, e.mouseUpOutside), e.hovering && !o && e.el.on(y, e.mouseLeave), e.hovering && o && _.on(b, e.mouseMoveOutside), window.clearTimeout(e.delayId);
                    }
                }
                function L(t, { immediate: e, forceClose: n } = {}) {
                    if (t.open && (!t.config.hover || !t.hovering || n)) {
                        t.toggle.attr("aria-expanded", "false"), t.open = !1;
                        var i = t.config;
                        if (v.outro(0, t.el[0]), _.off(x, t.mouseUpOutside), _.off(b, t.mouseMoveOutside), t.el.off(y, t.mouseLeave), window.clearTimeout(t.delayId), !i.delay || e) return t.complete();
                        t.delayId = window.setTimeout(t.complete, i.delay);
                    }
                }
                function I(t) {
                    t.links[t.selectedIdx] && t.links[t.selectedIdx].focus();
                }
                return c.ready = A, c.design = function() {
                    d && _.find(h).each(function(e, n) {
                        t(n).triggerHandler(k);
                    }), d = !1, A();
                }, c.preview = function() {
                    d = !0, A();
                }, c;
            });
        },
        655: function(t, e, n) {
            "use strict";
            var i = n(949), r = n(134);
            let o = {
                ARROW_LEFT: 37,
                ARROW_UP: 38,
                ARROW_RIGHT: 39,
                ARROW_DOWN: 40,
                ESCAPE: 27,
                SPACE: 32,
                ENTER: 13,
                HOME: 36,
                END: 35
            };
            i.define("navbar", t.exports = function(t, e) {
                var n, a, s, u, c = {}, l = t.tram, d = t(window), f = t(document), h = e.debounce, p = i.env(), v = ".w-nav", m = "w--open", g = "w--nav-dropdown-open", w = "w--nav-dropdown-toggle-open", b = "w--nav-dropdown-list-open", y = "w--nav-link-open", x = r.triggers, k = t();
                function E() {
                    i.resize.off(_);
                }
                function _() {
                    a.each(z);
                }
                function A(n, i) {
                    var r, a, c, l, h, p = t(i), m = t.data(i, v);
                    m || (m = t.data(i, v, {
                        open: !1,
                        el: p,
                        config: {},
                        selectedIdx: -1
                    })), m.menu = p.find(".w-nav-menu"), m.links = m.menu.find(".w-nav-link"), m.dropdowns = m.menu.find(".w-dropdown"), m.dropdownToggle = m.menu.find(".w-dropdown-toggle"), m.dropdownList = m.menu.find(".w-dropdown-list"), m.button = p.find(".w-nav-button"), m.container = p.find(".w-container"), m.overlayContainerId = "w-nav-overlay-" + n, m.outside = ((r = m).outside && f.off("click" + v, r.outside), function(e) {
                        var n = t(e.target);
                        u && n.closest(".w-editor-bem-EditorOverlay").length || N(r, n);
                    });
                    var g = p.find(".w-nav-brand");
                    g && "/" === g.attr("href") && null == g.attr("aria-label") && g.attr("aria-label", "home"), m.button.attr("style", "-webkit-user-select: text;"), null == m.button.attr("aria-label") && m.button.attr("aria-label", "menu"), m.button.attr("role", "button"), m.button.attr("tabindex", "0"), m.button.attr("aria-controls", m.overlayContainerId), m.button.attr("aria-haspopup", "menu"), m.button.attr("aria-expanded", "false"), m.el.off(v), m.button.off(v), m.menu.off(v), T(m), s ? (R(m), m.el.on("setting" + v, (a = m, function(t, n) {
                        n = n || {};
                        var i = d.width();
                        T(a), !0 === n.open && W(a, !0), !1 === n.open && q(a, !0), a.open && e.defer(function() {
                            i !== d.width() && L(a);
                        });
                    }))) : ((c = m).overlay || (c.overlay = t('<div class="w-nav-overlay" data-wf-ignore />').appendTo(c.el), c.overlay.attr("id", c.overlayContainerId), c.parent = c.menu.parent(), q(c, !0)), m.button.on("click" + v, I(m)), m.menu.on("click" + v, "a", D(m)), m.button.on("keydown" + v, (l = m, function(t) {
                        switch(t.keyCode){
                            case o.SPACE:
                            case o.ENTER:
                                return I(l)(), t.preventDefault(), t.stopPropagation();
                            case o.ESCAPE:
                                return q(l), t.preventDefault(), t.stopPropagation();
                            case o.ARROW_RIGHT:
                            case o.ARROW_DOWN:
                            case o.HOME:
                            case o.END:
                                if (!l.open) return t.preventDefault(), t.stopPropagation();
                                return t.keyCode === o.END ? l.selectedIdx = l.links.length - 1 : l.selectedIdx = 0, C(l), t.preventDefault(), t.stopPropagation();
                        }
                    })), m.el.on("keydown" + v, (h = m, function(t) {
                        if (h.open) switch(h.selectedIdx = h.links.index(document.activeElement), t.keyCode){
                            case o.HOME:
                            case o.END:
                                return t.keyCode === o.END ? h.selectedIdx = h.links.length - 1 : h.selectedIdx = 0, C(h), t.preventDefault(), t.stopPropagation();
                            case o.ESCAPE:
                                return q(h), h.button.focus(), t.preventDefault(), t.stopPropagation();
                            case o.ARROW_LEFT:
                            case o.ARROW_UP:
                                return h.selectedIdx = Math.max(-1, h.selectedIdx - 1), C(h), t.preventDefault(), t.stopPropagation();
                            case o.ARROW_RIGHT:
                            case o.ARROW_DOWN:
                                return h.selectedIdx = Math.min(h.links.length - 1, h.selectedIdx + 1), C(h), t.preventDefault(), t.stopPropagation();
                        }
                    }))), z(n, i);
                }
                function O(e, n) {
                    var i = t.data(n, v);
                    i && (R(i), t.removeData(n, v));
                }
                function R(t) {
                    t.overlay && (q(t, !0), t.overlay.remove(), t.overlay = null);
                }
                function T(t) {
                    var n = {}, i = t.config || {}, r = n.animation = t.el.attr("data-animation") || "default";
                    n.animOver = /^over/.test(r), n.animDirect = /left$/.test(r) ? -1 : 1, i.animation !== r && t.open && e.defer(L, t), n.easing = t.el.attr("data-easing") || "ease", n.easing2 = t.el.attr("data-easing2") || "ease";
                    var o = t.el.attr("data-duration");
                    n.duration = null != o ? Number(o) : 400, n.docHeight = t.el.attr("data-doc-height"), t.config = n;
                }
                function C(t) {
                    if (t.links[t.selectedIdx]) {
                        var e = t.links[t.selectedIdx];
                        e.focus(), D(e);
                    }
                }
                function L(t) {
                    t.open && (q(t, !0), W(t, !0));
                }
                function I(t) {
                    return h(function() {
                        t.open ? q(t) : W(t);
                    });
                }
                function D(e) {
                    return function(n) {
                        var r = t(this).attr("href");
                        if (!i.validClick(n.currentTarget)) return void n.preventDefault();
                        r && 0 === r.indexOf("#") && e.open && q(e);
                    };
                }
                c.ready = c.design = c.preview = function() {
                    s = p && i.env("design"), u = i.env("editor"), n = t(document.body), (a = f.find(v)).length && (a.each(A), E(), i.resize.on(_));
                }, c.destroy = function() {
                    k = t(), E(), a && a.length && a.each(O);
                };
                var N = h(function(t, e) {
                    if (t.open) {
                        var n = e.closest(".w-nav-menu");
                        t.menu.is(n) || q(t);
                    }
                });
                function z(e, n) {
                    var i = t.data(n, v), r = i.collapsed = "none" !== i.button.css("display");
                    if (!i.open || r || s || q(i, !0), i.container.length) {
                        var o, a = ("none" === (o = i.container.css(M)) && (o = ""), function(e, n) {
                            (n = t(n)).css(M, ""), "none" === n.css(M) && n.css(M, o);
                        });
                        i.links.each(a), i.dropdowns.each(a);
                    }
                    i.open && S(i);
                }
                var M = "max-width";
                function P(t, e) {
                    e.setAttribute("data-nav-menu-open", "");
                }
                function $(t, e) {
                    e.removeAttribute("data-nav-menu-open");
                }
                function W(t, e) {
                    if (!t.open) {
                        t.open = !0, t.menu.each(P), t.links.addClass(y), t.dropdowns.addClass(g), t.dropdownToggle.addClass(w), t.dropdownList.addClass(b), t.button.addClass(m);
                        var n = t.config;
                        ("none" === n.animation || !l.support.transform || n.duration <= 0) && (e = !0);
                        var r = S(t), o = t.menu.outerHeight(!0), a = t.menu.outerWidth(!0), u = t.el.height(), c = t.el[0];
                        if (z(0, c), x.intro(0, c), i.redraw.up(), s || f.on("click" + v, t.outside), e) return void h();
                        var d = "transform " + n.duration + "ms " + n.easing;
                        if (t.overlay && (k = t.menu.prev(), t.overlay.show().append(t.menu)), n.animOver) {
                            l(t.menu).add(d).set({
                                x: n.animDirect * a,
                                height: r
                            }).start({
                                x: 0
                            }).then(h), t.overlay && t.overlay.width(a);
                            return;
                        }
                        l(t.menu).add(d).set({
                            y: -(u + o)
                        }).start({
                            y: 0
                        }).then(h);
                    }
                    function h() {
                        t.button.attr("aria-expanded", "true");
                    }
                }
                function S(t) {
                    var e = t.config, i = e.docHeight ? f.height() : n.height();
                    return e.animOver ? t.menu.height(i) : "fixed" !== t.el.css("position") && (i -= t.el.outerHeight(!0)), t.overlay && t.overlay.height(i), i;
                }
                function q(t, e) {
                    if (t.open) {
                        t.open = !1, t.button.removeClass(m);
                        var n = t.config;
                        if (("none" === n.animation || !l.support.transform || n.duration <= 0) && (e = !0), x.outro(0, t.el[0]), f.off("click" + v, t.outside), e) {
                            l(t.menu).stop(), s();
                            return;
                        }
                        var i = "transform " + n.duration + "ms " + n.easing2, r = t.menu.outerHeight(!0), o = t.menu.outerWidth(!0), a = t.el.height();
                        if (n.animOver) return void l(t.menu).add(i).start({
                            x: o * n.animDirect
                        }).then(s);
                        l(t.menu).add(i).start({
                            y: -(a + r)
                        }).then(s);
                    }
                    function s() {
                        t.menu.height(""), l(t.menu).set({
                            x: 0,
                            y: 0
                        }), t.menu.each($), t.links.removeClass(y), t.dropdowns.removeClass(g), t.dropdownToggle.removeClass(w), t.dropdownList.removeClass(b), t.overlay && t.overlay.children().length && (k.length ? t.menu.insertAfter(k) : t.menu.prependTo(t.parent), t.overlay.attr("style", "").hide()), t.el.triggerHandler("w-close"), t.button.attr("aria-expanded", "false");
                    }
                }
                return c;
            });
        },
        78: function(t, e, n) {
            "use strict";
            var i = n(949), r = n(134);
            i.define("tabs", t.exports = function(t) {
                var e, n, o = {}, a = t.tram, s = t(document), u = i.env, c = u.safari, l = u(), d = "data-w-tab", f = ".w-tabs", h = "w--current", p = "w--tab-active", v = r.triggers, m = !1;
                function g() {
                    n = l && i.env("design"), (e = s.find(f)).length && (e.each(y), i.env("preview") && !m && e.each(b), w(), i.redraw.on(o.redraw));
                }
                function w() {
                    i.redraw.off(o.redraw);
                }
                function b(e, n) {
                    var i = t.data(n, f);
                    i && (i.links && i.links.each(v.reset), i.panes && i.panes.each(v.reset));
                }
                function y(e, i) {
                    var r = f.substr(1) + "-" + e, o = t(i), a = t.data(i, f);
                    if (a || (a = t.data(i, f, {
                        el: o,
                        config: {}
                    })), a.current = null, a.tabIdentifier = r + "-" + d, a.paneIdentifier = r + "-data-w-pane", a.menu = o.children(".w-tab-menu"), a.links = a.menu.children(".w-tab-link"), a.content = o.children(".w-tab-content"), a.panes = a.content.children(".w-tab-pane"), a.el.off(f), a.links.off(f), a.menu.attr("role", "tablist"), a.links.attr("tabindex", "-1"), (u = {}).easing = (s = a).el.attr("data-easing") || "ease", c = u.intro = (c = parseInt(s.el.attr("data-duration-in"), 10)) == c ? c : 0, l = u.outro = (l = parseInt(s.el.attr("data-duration-out"), 10)) == l ? l : 0, u.immediate = !c && !l, s.config = u, !n) {
                        a.links.on("click" + f, (p = a, function(t) {
                            t.preventDefault();
                            var e = t.currentTarget.getAttribute(d);
                            e && x(p, {
                                tab: e
                            });
                        })), a.links.on("keydown" + f, (v = a, function(t) {
                            var e, n = (e = v.current, Array.prototype.findIndex.call(v.links, (t)=>t.getAttribute(d) === e, null)), i = t.key, r = {
                                ArrowLeft: n - 1,
                                ArrowUp: n - 1,
                                ArrowRight: n + 1,
                                ArrowDown: n + 1,
                                End: v.links.length - 1,
                                Home: 0
                            };
                            if (i in r) {
                                t.preventDefault();
                                var o = r[i];
                                -1 === o && (o = v.links.length - 1), o === v.links.length && (o = 0);
                                var a = v.links[o].getAttribute(d);
                                a && x(v, {
                                    tab: a
                                });
                            }
                        }));
                        var s, u, c, l, p, v, m = a.links.filter("." + h).attr(d);
                        m && x(a, {
                            tab: m,
                            immediate: !0
                        });
                    }
                }
                function x(e, n) {
                    n = n || {};
                    var r, o = e.config, s = o.easing, u = n.tab;
                    if (u !== e.current) {
                        e.current = u, e.links.each(function(i, a) {
                            var s = t(a);
                            if (n.immediate || o.immediate) {
                                var c = e.panes[i];
                                a.id || (a.id = e.tabIdentifier + "-" + i), c.id || (c.id = e.paneIdentifier + "-" + i), a.href = "#" + c.id, a.setAttribute("role", "tab"), a.setAttribute("aria-controls", c.id), a.setAttribute("aria-selected", "false"), c.setAttribute("role", "tabpanel"), c.setAttribute("aria-labelledby", a.id);
                            }
                            a.getAttribute(d) === u ? (r = a, s.addClass(h).removeAttr("tabindex").attr({
                                "aria-selected": "true"
                            }).each(v.intro)) : s.hasClass(h) && s.removeClass(h).attr({
                                tabindex: "-1",
                                "aria-selected": "false"
                            }).each(v.outro);
                        });
                        var l = [], f = [];
                        e.panes.each(function(e, n) {
                            var i = t(n);
                            n.getAttribute(d) === u ? l.push(n) : i.hasClass(p) && f.push(n);
                        });
                        var g = t(l), w = t(f);
                        if (n.immediate || o.immediate) {
                            g.addClass(p).each(v.intro), w.removeClass(p), m || i.redraw.up();
                            return;
                        }
                        var b = window.scrollX, y = window.scrollY;
                        r.focus(), window.scrollTo(b, y), w.length && o.outro ? (w.each(v.outro), a(w).add("opacity " + o.outro + "ms " + s, {
                            fallback: c
                        }).start({
                            opacity: 0
                        }).then(()=>k(o, w, g))) : k(o, w, g);
                    }
                }
                function k(t, e, n) {
                    if (e.removeClass(p).css({
                        opacity: "",
                        transition: "",
                        transform: "",
                        width: "",
                        height: ""
                    }), n.addClass(p).each(v.intro), i.redraw.up(), !t.intro) return a(n).set({
                        opacity: 1
                    });
                    a(n).set({
                        opacity: 0
                    }).redraw().add("opacity " + t.intro + "ms " + t.easing, {
                        fallback: c
                    }).start({
                        opacity: 1
                    });
                }
                return o.ready = o.design = o.preview = g, o.redraw = function() {
                    m = !0, g(), m = !1;
                }, o.destroy = function() {
                    (e = s.find(f)).length && (e.each(b), w());
                }, o;
            });
        }
    }, e = {};
    function n(i) {
        var r = e[i];
        if (void 0 !== r) return r.exports;
        var o = e[i] = {
            exports: {}
        };
        return t[i](o, o.exports, n), o.exports;
    }
    n.rv = ()=>"1.3.9", n.ruid = "bundler=rspack@1.3.9", n(461), n(624), n(286), n(334), n(338), n(695), n(655), n(858), n(78);
})();

//# sourceMappingURL=index.a22cff43.js.map
